// ThemeProviderWrapper.tsx
import React, { useEffect, useState } from "react";
import { ConfigProvider, Switch, Space } from "antd";
import { ThemeProvider } from "styled-components";
import {
  lightAlgorithm,
  darkAlgorithm,
  lightTheme,
  darkTheme,
} from "./themeConfig";
import { GlobalStyle } from "./globalStyle";
import { MoonOutlined, SunOutlined } from "@ant-design/icons";

interface ThemeProviderWrapperProps {
  children: React.ReactNode;
}

export const THEME_KEY = "app-theme";

const ThemeProviderWrapper: React.FC<ThemeProviderWrapperProps> = ({
  children,
}) => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem(THEME_KEY) === "dark";
    }
    return false;
  });

  const currentTheme = isDarkMode ? darkTheme : lightTheme;
  const currentAlgorithm = isDarkMode ? darkAlgorithm : lightAlgorithm;

  const toggleTheme = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem(THEME_KEY, newMode ? "dark" : "light");
  };

  useEffect(() => {
    document.body.setAttribute("data-theme", currentTheme.name);
  }, [isDarkMode]);

  return (
    <ConfigProvider theme={{ algorithm: currentAlgorithm }}>
      <ThemeProvider theme={currentTheme}>
        <GlobalStyle />
        <div
          style={{
            position: "fixed",
            top: 16,
            right: 16,
            zIndex: 1000,
            background: "transparent",
          }}
        >
          <Space>
            <SunOutlined style={{ color: !isDarkMode ? "#faad14" : "#888" }} />
            <Switch checked={isDarkMode} onChange={toggleTheme} />
            <MoonOutlined style={{ color: isDarkMode ? "#1677ff" : "#888" }} />
          </Space>
        </div>
        {children}
      </ThemeProvider>
    </ConfigProvider>
  );
};

export default ThemeProviderWrapper;
